import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import FontKeys from '../FontKeys';
import gameData from '../gameData';
import UIAssetKeys from '../UIAssetKeys';
import ABCyaLib from '@abcya/abcya_lib';

export default class CompletedLetterView extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     */
    constructor(scene)
    {
        super(scene);

        // for debugging
        if (gameData.letterData.date == "" &&
            gameData.letterData.address == "" &&
            gameData.letterData.body == "" &&
            gameData.letterData.salutation == "" &&
            gameData.letterData.closing == "" &&
            gameData.letterData.signature == "")
        {
            // add some testing values
            gameData.letterData.date = "July 8th, 2022";
            gameData.letterData.address = "4 Richmond Sq\nProvidence, RI 00000";
            gameData.letterData.body = "This is some long text that will go into the body of the letter. It is long enough to span multiple lines and give an example of what the text will look like.";
            gameData.letterData.salutation = "Future Developer,";
            gameData.letterData.closing = "Good luck,";
            gameData.letterData.signature = "Stephen Read";
        }

        this.letterWidth = 578;
        this.letterHeight = 650;
        this.borderWidth = 30;

        this.bg = this.scene.add.rectangle(0, 0, this.letterWidth, this.letterHeight, 0xffffff).setOrigin(0);
        this.add(this.bg);

        this.createLetterParts();
    }

    createLetterParts()
    {
        // date
        let date = ABCyaPhaser.Text.addText(0, 0, 18, 0x000000, FontKeys._asapregular, gameData.letterData['date'], this, false).setOrigin(0);
        let dateWidth = (date.text == "") ? 0 : date.width;
        date.x = this.letterWidth - dateWidth - this.borderWidth;
        date.y = this.borderWidth;
        //address
        let address = ABCyaPhaser.Text.addText(0, 0, 18, 0x000000, FontKeys._asapregular, gameData.letterData['address'], this, false).setOrigin(0);
        address.x = this.letterWidth / 2;
        address.y = date.y + date.height + 10;

        //line up address and date
        date.x = address.x;

        let salutation = ABCyaPhaser.Text.addText(0, 0, 18, 0x000000, FontKeys._asapregular, ABCyaPhaser.Localization.instance.getLocalizedString("creation.dear") + " " + gameData.letterData['salutation'], this, false).setOrigin(0);
        salutation.x = this.borderWidth;
        salutation.y = address.y + address.height + 40;

        //format body text
        let rExp = /[\r]/gi;
        let bodyString = gameData.letterData['body'];
        let pArray = bodyString.split(rExp);
        let newBodyString = "";

        for (let i = 0; i < pArray.length; i++)
        {
            //remove blank lines (extra returns) or blank paragraphs
            if (pArray[i] != "" && pArray[i] != " " && pArray[i] != "\r")
            {
                //remove tabs added into input
                let tExp = /(\t)/;
                let stringPiece = pArray[i];

                if (stringPiece.indexOf("\t") == 0) stringPiece = stringPiece.substr(1);
                stringPiece.split(tExp).join("");
                //remove all spaces at beginning of paragraph, in case user indents that way
                while (stringPiece.charAt(0) == " ")
                {
                    stringPiece = stringPiece.substr(1);
                }

                newBodyString += ABCyaLib.Environment.instance.gameConfig.bodyIndentString + stringPiece + "\n";
            }
        }

        let body = ABCyaPhaser.Text.addText(0, 0, 18, 0x000000, FontKeys._asapregular, newBodyString, this, false).setOrigin(0).setWordWrapWidth(this.letterWidth - 100);
        body.x = this.borderWidth;
        body.y = salutation.y + salutation.height + 30;

        let closing = ABCyaPhaser.Text.addText(0, 0, 18, 0x000000, FontKeys._asapregular, gameData.letterData['closing'], this, false).setOrigin(0);
        closing.x = this.letterWidth / 2;
        closing.y = body.y + body.height + 40;

        let signature = ABCyaPhaser.Text.addText(0, 0, 18, 0x000000, FontKeys._asapregular, gameData.letterData['signature'], this, false).setOrigin(0);
        signature.x = this.letterWidth / 2;
        signature.y = closing.y + closing.height + 10;

        let footer = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._footer, this);
        footer.scale = 0.6;

        footer.x = 280;
        footer.y = this.letterHeight - footer.height/2 - 5;

        ABCyaPhaser.Text.addText(footer.x - 37, footer.y + 3, 9, 0x666666, FontKeys._AsapReg, ABCyaPhaser.Localization.instance.getLocalizedString('letter.created'), this, true).setOrigin(0.5).setResolution(1.5);
    }
}